"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = __importDefault(require("@components/Modal/index"));
var Button_1 = __importStar(require("@components/Button"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
function DeleteQueueModal(props) {
    var onDelete = props.onDelete, isOpen = props.isOpen, setIsOpen = props.setIsOpen, queueRules = props.queueRules, selectedQueue = props.selectedQueue, angularJsDependencies = props.angularJsDependencies, domain = props.domain;
    var currentQueueName = selectedQueue === null || selectedQueue === void 0 ? void 0 : selectedQueue.label;
    var numberOfItemsInQueue = (selectedQueue === null || selectedQueue === void 0 ? void 0 : selectedQueue.count) || 0;
    var hasFilters = queueRules.length > 0;
    var t = (0, react_i18next_1.useTranslation)().t;
    // When you add an event listener, it captures the state at the time of its definition and doesn't automatically update when the state changes.
    var isOpenRef = (0, react_1.useRef)(isOpen);
    var onDeleteRef = (0, react_1.useRef)(onDelete);
    var numberOfItemsInQueueRef = (0, react_1.useRef)(numberOfItemsInQueue);
    var hasFiltersRef = (0, react_1.useRef)(hasFilters);
    (0, react_1.useEffect)(function () {
        isOpenRef.current = isOpen;
    }, [isOpen]);
    (0, react_1.useEffect)(function () {
        onDeleteRef.current = onDelete;
    }, [onDelete]);
    (0, react_1.useEffect)(function () {
        numberOfItemsInQueueRef.current = numberOfItemsInQueue;
    }, [numberOfItemsInQueue]);
    (0, react_1.useEffect)(function () {
        hasFiltersRef.current = hasFilters;
    }, [hasFilters]);
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' && isOpenRef.current && !hasFiltersRef.current && numberOfItemsInQueueRef.current === 0) {
            onDeleteRef.current();
            setIsOpen(false);
        }
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (react_1.default.createElement(index_1.default, { isOpen: isOpen, setIsOpen: setIsOpen },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('delete-queue-modal', { 'delete-disabled': queueRules }) },
            react_1.default.createElement("h3", { className: "delete-modal__title" }, t('MANUAL.DELETE_QUEUE_POPOVER.NO_ITEMS_IN_QUEUE.TITLE')),
            !hasFilters && numberOfItemsInQueue === 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: "delete-modal__text" },
                    t('MANUAL.DELETE_QUEUE_POPOVER.NO_ITEMS_IN_QUEUE.CONFIRM_DELETE_TEXT'),
                    " ",
                    react_1.default.createElement("b", null, currentQueueName),
                    "?"),
                react_1.default.createElement("div", { className: "delete-modal__button-group" },
                    react_1.default.createElement(Button_1.SecondaryButton, { text: t('MANUAL.DELETE_QUEUE_POPOVER.NO_ITEMS_IN_QUEUE.AFFIRM_DELETE_BTN'), onClick: function () { return setIsOpen(false); } }),
                    react_1.default.createElement(Button_1.default, { text: t('MANUAL.DELETE_QUEUE_POPOVER.NO_ITEMS_IN_QUEUE.CONFIRM_DELETE_BTN'), onClick: function () {
                            onDelete();
                            setIsOpen(false);
                        } })))),
            (hasFilters || numberOfItemsInQueue > 0) && (react_1.default.createElement("div", null,
                react_1.default.createElement("b", null, t('MANUAL.DELETE_QUEUE_POPOVER.ITEMS_IN_QUEUE.TEXT_REACT', { currentQueueName: currentQueueName })),
                react_1.default.createElement("ul", null,
                    numberOfItemsInQueue > 0 && (react_1.default.createElement("li", null,
                        t('MANUAL.DELETE_QUEUE_POPOVER.ITEMS_IN_QUEUE.SUB_TEXT1'),
                        react_1.default.createElement("b", null,
                            "(",
                            numberOfItemsInQueue,
                            ")"))),
                    hasFilters && (react_1.default.createElement("li", { dangerouslySetInnerHTML: { __html: t('MANUAL.DELETE_QUEUE_POPOVER.ITEMS_IN_QUEUE.SUB_TEXT2') } }))),
                hasFilters && (react_1.default.createElement("div", { className: "delete-queue-modal-rules" },
                    react_1.default.createElement("b", null, t('MANUAL.DELETE_QUEUE_POPOVER.FILTERS_USE_BY_QUEUE.TEXT')),
                    queueRules.map(function (rule) { return (react_1.default.createElement("div", null,
                        react_1.default.createElement("a", { href: angularJsDependencies.href('app.assignment.automation.filterView', {
                                domain: domain,
                                filterId: rule.id,
                                from: rule.from,
                            }), target: "_blank", rel: "noreferrer" },
                            react_1.default.createElement("span", null, rule.name),
                            react_1.default.createElement("i", { className: "implioicons-open-in-tab" })))); }),
                    react_1.default.createElement(Button_1.default, { text: t('MANUAL.DELETE_QUEUE_POPOVER.FILTERS_USE_BY_QUEUE.BTN'), onClick: function () { return setIsOpen(false); } }))),
                !hasFilters && (react_1.default.createElement("div", { className: "no-filters-used" },
                    react_1.default.createElement(Button_1.default, { text: t('MANUAL.DELETE_QUEUE_POPOVER.NO_FILTER_USE_BY_QUEUE.BTN'), onClick: function () { return setIsOpen(false); } }))))))));
}
exports.default = DeleteQueueModal;
